export default __webpack_public_path__ + "static/color-analysis-color-groups-d8f5527748a5a65e54d2230d0feae096.jpg";